import TomSelect from 'tom-select'
import Lang from './Lang.js'
import HttpClient from './HttpClient.js'
import Swal from 'sweetalert2'

export default class MultiSelect {
    #minimalConfig = {
        selectOnTab: true,
        maxOptions: null,
        hidePlaceholder: true,
        plugins: {
            clear_button: {
                title: Lang.get('general.remove'),
            },
        },
        persist: true,
        render: {
            no_results: function () {
                return '<div class="no-results">' + Lang.get('general.no_results') + '</div>'
            },
        },
    }

    #singleCreationConfig = {
        selectOnTab: true,
        maxOptions: null,
        maxItems: 1,
        hidePlaceholder: true,
        persist: false,
        create: async (input, callback) => {
            return this.saveItem(input, callback)
        },
        render: {
            no_results: function () {
                return '<div class="no-results">' + Lang.get('general.no_results') + '</div>'
            },
        },
    }

    #multipleCreationConfig = {
        selectOnTab: true,
        maxOptions: null,
        plugins: {
            remove_button: {
                title: Lang.get('general.remove'),
            },
        },
        persist: true,
        create: async (input, callback) => {
            return this.saveItem(input, callback)
        },
        render: {
            no_results: function () {
                return '<div class="no-results">' + Lang.get('general.no_results') + '</div>'
            },
        },
    }

    #url

    #single

    #httpClient

    #instance

    #toggleElement

    #toggleValue

    constructor(element) {
        this.#httpClient = new HttpClient()

        this.#url = element.getAttribute('data-url') ?? false
        this.#single = element.getAttribute('data-single') ?? false
        this.#toggleElement = element.getAttribute('data-toggle') ?? false
        this.#toggleValue = element.getAttribute('data-toggle-value') ?? false

        let config = this.#url
            ? this.#single
                ? this.#singleCreationConfig
                : this.#multipleCreationConfig
            : this.#minimalConfig

        this.#instance = new TomSelect(element, config)

        this.#setupToggleElement(element.id)
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new MultiSelect(element))
    }

    #setupToggleElement(id) {
        if (!this.#toggleElement) {
            return
        }

        const toggle = document.getElementById(this.#toggleElement)
        const selectElement = document.getElementById(id + 'Wrapper')

        if (!this.#shouldDisplay(toggle)) {
            selectElement.classList.add('d-none')
        }

        toggle.addEventListener('change', () => {
            this.#instance.clear(true)

            if (this.#shouldDisplay(toggle)) {
                selectElement.classList.remove('d-none')
            } else {
                selectElement.classList.add('d-none')
            }
        })
    }

    #shouldDisplay(toggleElement) {
        if (typeof toggleElement.checked !== 'undefined') {
            return !toggleElement.checked
        }

        return toggleElement.value === this.#toggleValue
    }

    async saveItem(data, callback) {
        try {
            let response = await this.#httpClient.post(this.#url, { name: data })

            let responseData = response.data.data

            return await callback({ value: responseData.id, text: responseData.attributes.name })
        } catch (error) {
            if (error.response.status === 422) {
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.message,
                    text: Lang.get('skill.actions.create.failed'),
                })

                return
            }

            Swal.fire({
                icon: 'error',
                title: Lang.get('general.oops'),
                text: Lang.get('skill.actions.create.failed'),
            })
        }
    }
}
